import { oneDriveBusinessUrlRegex, oneDriveConsumerUrlRegex, sharePointUrlRegex, } from './constants';
export function getReferralFromFileLocation(url) {
    if (url && url.length) {
        if (url.match(oneDriveBusinessUrlRegex) ||
            url.match(oneDriveConsumerUrlRegex)) {
            return "Documents" /* KnownWorkloadReferralNames.OneDrive */;
        }
        if (url.match(sharePointUrlRegex)) {
            return "Sites" /* KnownWorkloadReferralNames.SharePoint */;
        }
    }
    return undefined;
}
//# sourceMappingURL=getReferralFromFileLocation.js.map